export { GlobalHeader, GlobalHeader as default } from './GlobalHeader'
export { TheWestHeader } from './components/TheWestHeader'
export * from './types'
